import styles from './PartDeliveryDate.module.css'
import { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
// Radix UI
import * as RadioGroup from '@radix-ui/react-radio-group';
// Icons
import {ReactComponent as IconPlus} from '../../../../../assets/img/icons/plus.svg'
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { setDeliveryDate } from '../../../../../../../features/cart/cartSlice';
// Date picker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ru } from 'date-fns/locale/ru';


const DateBlock = ({arrayDeliveryData}) => {
    const arrayExcludedDates = arrayDeliveryData?.excludeDates.map(dateString => new Date(dateString));
    const arrayExcludedDaysOfWeek = Object.entries(arrayDeliveryData.excludedDaysOfWeek)
                                        .filter(([day, details]) => !details.delivery_active)
                                        .map( (array) => parseInt(array[0]))

    // redux
    const dispatch = useDispatch()
    const saveDeliveryDate = useCallback((date) => dispatch(setDeliveryDate(date)), [dispatch])

    // DATE STATES
    // ВАЖНО: Блок "сегодня" временно отключен (может быть возвращен позже)
    // Логика: до 17:00 - доставка завтра, после 17:00 - доставка послезавтра
    const [isDeliveryPossibleToday, setIsDeliveryPossibleToday] = useState(false) // Временно отключено (было true)
    const [isDeliveryPossibleTomorrow, setIsDeliveryPossibleTomorrow] = useState(true)
    const [isDeliveryPossibleDayAfterTomorrow, setIsDeliveryPossibleDayAfterTomorrow] = useState(true) // Новый блок "послезавтра"

    const [deliveryDay, setDeliveryDay] = useState('')
    const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];


    // Get the current time
    const currentTime = new Date();
    // Get the hours and minutes from the current time
    const currentHours = currentTime.getHours();
    const currentMinutes = currentTime.getMinutes();
    
    // ГРАНИЦА ВРЕМЕНИ ДЛЯ ВЫБОРА ДОСТАВКИ
    // До 17:00 - можно выбрать "завтра"
    // После 17:00 - доступна только "послезавтра" и далее
    const cutoffHours = 17; // Граничное время - 17:00
    const cutoffMinutes = 0;

    /////////////////////////////////////////////////////////////
    /////////////////////////// TODAY ///////////////////////////
    /////////////////////////////////////////////////////////////
    // БЛОК "СЕГОДНЯ" ВРЕМЕННО ОТКЛЮЧЕН
    // Может быть возвращен позже для доставки "день в день"
    // Код сохранен для возможного восстановления функционала

    const todayDate = useMemo(() => {
        const date = new Date();
        date.getDate()
        date.setHours(0, 0, 0, 0);
        return date;
    }, []);
    const todayDay = todayDate.getDate();
    const todayMonth = months[todayDate.getMonth()];

    // ОТКЛЮЧЕНО: possible to deliver today
    // Оставлено закомментированным для возможного восстановления
    useEffect( () => {                                                         
        // const isPossibleToDeliverToday =    !arrayExcludedDaysOfWeek.includes(currentTime.getDay()) &&
        //                                     !arrayExcludedDates.some(excludedDay => excludedDay.getTime() === currentTime.getTime()) &&
        //                                     (currentHours < targetHours || (currentHours === targetHours && currentMinutes < targetMinutes)) 
        
        // ВРЕМЕННО: всегда false - блок отключен
        const isPossibleToDeliverToday = false;
        setIsDeliveryPossibleToday(isPossibleToDeliverToday)
        
        // Код ниже не выполняется, т.к. isPossibleToDeliverToday всегда false
        if(isPossibleToDeliverToday){
            setDeliveryDay('today')
            saveDeliveryDate(todayDate.getTime())
        } 
    }, [todayDate])
    
    // component - ОТКЛЮЧЕН, но сохранен в коде
    const BlockToday = () => (
        <div className={`card__content ${styles.card__content}`}>
            <div className={styles.radioGroupBlock}>
                <RadioGroup.Item disabled={!isDeliveryPossibleToday} className={styles.radioGroupItem} value="today" id="r1">
                    <RadioGroup.Indicator className={styles.radioGroupIndicator} />
                </RadioGroup.Item>
                <label className={styles.label} htmlFor="r1">
                    <span className={styles.date}>{todayDay} {todayMonth}</span>
                </label>
            </div>
            <p className={`${styles.deliveryPayment} ${styles.pl30}`}>сегодня</p>
            <p className={`${styles.deliveryPayment} ${styles.pl30}`}>Бесплатно</p>
        </div>
    )

    /////////////////////////////////////////////////////////////
    ////////////////////////// TOMORROW /////////////////////////
    /////////////////////////////////////////////////////////////
    // ВАЖНО: Доступность блока "завтра" зависит от текущего времени
    // До 17:00 - блок активен
    // После 17:00 - блок недоступен (доставка возможна только послезавтра)

    const tomorrowDate = useMemo(() => {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }, []);
    const tomorrowDay = tomorrowDate.getDate();
    const tomorrowMonth = months[tomorrowDate.getMonth()];

    // Проверка возможности доставки завтра
    useEffect( () => {
        // Проверяем:
        // 1. Завтра не выходной день (не в arrayExcludedDaysOfWeek)
        // 2. Завтра не в списке исключенных дат (arrayExcludedDates)
        // 3. НОВОЕ: Текущее время до 17:00
        const isBeforeCutoff = currentHours < cutoffHours || (currentHours === cutoffHours && currentMinutes < cutoffMinutes);
        
        const isPossibleToDeliverTomorrow = 
                                            !arrayExcludedDaysOfWeek.includes(tomorrowDate.getDay()) &&
                                            !arrayExcludedDates.some(excludedDay => excludedDay.getTime() === tomorrowDate.getTime()) &&
                                            isBeforeCutoff; // Добавлена проверка времени
        
        setIsDeliveryPossibleTomorrow(isPossibleToDeliverTomorrow)
       
        // Если доставка завтра возможна И доставка сегодня невозможна
        // (сегодня всегда невозможна, т.к. блок отключен)
        if(isPossibleToDeliverTomorrow && !isDeliveryPossibleToday){
            setDeliveryDay('tomorrow')
            saveDeliveryDate(tomorrowDate.getTime())
        }
    }, [isDeliveryPossibleToday, tomorrowDate])

    // component
    const BlockTomorrow = () => (
        <div className={`card__content ${styles.card__content}`}>
            <div className={styles.radioGroupBlock}>
                <RadioGroup.Item disabled={!isDeliveryPossibleTomorrow} className={styles.radioGroupItem} value="tomorrow" id="r2">
                    <RadioGroup.Indicator className={styles.radioGroupIndicator} />
                </RadioGroup.Item>
                <label className={styles.label} htmlFor="r2">
                    <span className={styles.date}>{tomorrowDay} {tomorrowMonth}</span>
                </label>
            </div>
            <p className={`${styles.deliveryPayment} ${styles.pl30}`}>завтра</p>
            <p className={`${styles.deliveryPayment} ${styles.pl30}`}>Бесплатно</p>
        </div>
    )
    
    /////////////////////////////////////////////////////////////
    /////////////////////// DAY AFTER TOMORROW //////////////////
    /////////////////////////////////////////////////////////////
    // НОВЫЙ БЛОК: Послезавтра
    // Становится основным вариантом после 17:00

    const dayAfterTomorrowDate = useMemo(() => {
        const date = new Date();
        date.setDate(date.getDate() + 2); // +2 дня от сегодня
        date.setHours(0, 0, 0, 0);
        return date;
    }, []);
    const dayAfterTomorrowDay = dayAfterTomorrowDate.getDate();
    const dayAfterTomorrowMonth = months[dayAfterTomorrowDate.getMonth()];

    // Проверка возможности доставки послезавтра
    useEffect( () => {
        // Проверяем:
        // 1. Послезавтра не выходной день
        // 2. Послезавтра не в списке исключенных дат
        const isPossibleToDeliverDayAfterTomorrow = 
                                            !arrayExcludedDaysOfWeek.includes(dayAfterTomorrowDate.getDay()) &&
                                            !arrayExcludedDates.some(excludedDay => excludedDay.getTime() === dayAfterTomorrowDate.getTime());
        
        setIsDeliveryPossibleDayAfterTomorrow(isPossibleToDeliverDayAfterTomorrow)
       
        // Если доставка послезавтра возможна И доставка завтра невозможна
        // Это означает либо после 17:00, либо завтра выходной
        if(isPossibleToDeliverDayAfterTomorrow && !isDeliveryPossibleTomorrow && !isDeliveryPossibleToday){
            setDeliveryDay('dayAfterTomorrow')
            saveDeliveryDate(dayAfterTomorrowDate.getTime())
        }
    }, [isDeliveryPossibleToday, isDeliveryPossibleTomorrow, dayAfterTomorrowDate])

    // component
    const BlockDayAfterTomorrow = () => (
        <div className={`card__content ${styles.card__content}`}>
            <div className={styles.radioGroupBlock}>
                <RadioGroup.Item disabled={!isDeliveryPossibleDayAfterTomorrow} className={styles.radioGroupItem} value="dayAfterTomorrow" id="r3">
                    <RadioGroup.Indicator className={styles.radioGroupIndicator} />
                </RadioGroup.Item>
                <label className={styles.label} htmlFor="r3">
                    <span className={styles.date}>{dayAfterTomorrowDay} {dayAfterTomorrowMonth}</span>
                </label>
            </div>
            <p className={`${styles.deliveryPayment} ${styles.pl30}`}>послезавтра</p>
            <p className={`${styles.deliveryPayment} ${styles.pl30}`}>Бесплатно</p>
        </div>
    )

    /////////////////////////////////////////////////////////////
    //////////////////////// CUSTOM DATE ////////////////////////
    /////////////////////////////////////////////////////////////
    // Выборочная дата - начинается от "послезавтра + 1 день"
    // Теперь стартует с +3 дня от сегодня (т.к. есть блок "послезавтра")
    
    const getNextValidDate = () => {
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 3); // Начинаем с +3 дня (было +2)
        currentDate.setHours(0, 0, 0, 0);

        // Пропускаем воскресенья и исключенные даты
        while (currentDate.getDay() === 0 || arrayExcludedDates.some(excludedDay => excludedDay.getTime() === currentDate.getTime())) {
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return currentDate;
    };
    const [selectedDateOnDatePicker, setSelectedDateOnDatePicker] = useState(getNextValidDate);

    // Фильтр для календаря - показываем только даты после "послезавтра"
    const filterOnlyDeliveryDates = (date) => {
        return  date > dayAfterTomorrowDate && // Изменено с tomorrowDate на dayAfterTomorrowDate
                !arrayExcludedDaysOfWeek.includes(date.getDay())
    };

    const CustomDateInput = forwardRef(({ value, onClick }, ref) => {
        const customDay = selectedDateOnDatePicker.getDate();
        const customMonth = months[selectedDateOnDatePicker.getMonth()];
        
        return <button type='button' className={styles.customDateBtn} onClick={onClick} ref={ref}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1em"
                            height="1em"
                            viewBox="0 0 48 48"
                        >
                            <mask id="ipSApplication0">
                                <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                                <path
                                    fill="#fff"
                                    d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                                ></path>
                                </g>
                            </mask>
                            <path
                                // fill="currentColor"
                                fill="#959595"
                                d="M0 0h48v48H0z"
                                mask="url(#ipSApplication0)"
                            ></path>
                        </svg>
                        {customDay} {customMonth}
                    </button>
    });

    // АВТОМАТИЧЕСКИЙ ВЫБОР выборочной даты
    // Если недоступны "сегодня", "завтра" и "послезавтра"
    useEffect( () => {
        if(!isDeliveryPossibleToday && !isDeliveryPossibleTomorrow && !isDeliveryPossibleDayAfterTomorrow){
            setDeliveryDay('custom-date')
            saveDeliveryDate(selectedDateOnDatePicker.getTime())   
        }
    },[isDeliveryPossibleToday, isDeliveryPossibleTomorrow, isDeliveryPossibleDayAfterTomorrow])
    
    // component
    const BlockCustomDate = () => (
        <div className={`card__content ${styles.card__content}`}>
            <div className={styles.radioGroupBlock}>
                <RadioGroup.Item className={styles.radioGroupItem} value="custom-date" id="r4">
                    <RadioGroup.Indicator className={styles.radioGroupIndicator} />
                </RadioGroup.Item>
                <label className={styles.label} htmlFor="r4">
                    <span className={styles.date}>Выбрать дату</span>
                </label>
            </div>
            <DatePicker
                        portalId="root-portal"
                        wrapperClassName={styles.datePickerWrapper}
                        selected={selectedDateOnDatePicker}
                        customInput={<CustomDateInput />}
                        onChange={(date) => {
                                            date.setHours(0, 0, 0, 0);
                                            saveDeliveryDate(date.getTime())
                                            setSelectedDateOnDatePicker(date)
                                            // change Radio button to Custom date
                                            setDeliveryDay('custom-date')
                                        }}
                        filterDate={filterOnlyDeliveryDates}
                        excludeDates={arrayExcludedDates}
                        calendarStartDay={1}
                        locale={ru}
                        withPortal
            />
            <p className={`${styles.deliveryPayment} ${styles.pl30}`}>Бесплатно</p>                    
        </div>
    )

    /////////////////////////////////////////////////////////////
    //////////////////////// RADIO GROUP ////////////////////////
    /////////////////////////////////////////////////////////////
    // Обработка выбора даты доставки
    const handleDateChange = (value) => {
        setDeliveryDay(value)

        // В зависимости от выбранного значения сохраняем соответствующую дату
        if(value==='today'){
            saveDeliveryDate(todayDate.getTime())
        }else if(value==='tomorrow'){
            saveDeliveryDate(tomorrowDate.getTime())
        }else if(value==='dayAfterTomorrow'){ // Новый вариант
            saveDeliveryDate(dayAfterTomorrowDate.getTime())
        }else{
            saveDeliveryDate(selectedDateOnDatePicker.getTime())
        }
    }

    /////////////////////////////////////////////////////////////
    ////////////////////////// RETURN ///////////////////////////
    /////////////////////////////////////////////////////////////
    return (
            <RadioGroup.Root 
                    className={styles.RadioGroupRoot} 
                    defaultValue="tomorrow" // Изменено с "today" на "tomorrow"
                    aria-label="select item"
                    onValueChange={handleDateChange}
                    value={deliveryDay}
                    name='delivery_day'
            >
                    
                    {/* TODAY - ВРЕМЕННО СКРЫТ */}
                    {/* Блок сохранен в коде, но не отображается */}
                    {/* Раскомментируйте строку ниже для восстановления блока "сегодня" */}
                    {/* <BlockToday /> */}
                    
                    {/* TOMORROW - доступен до 17:00 */}
                    <BlockTomorrow />
                    
                    {/* DAY AFTER TOMORROW - НОВЫЙ БЛОК */}
                    <BlockDayAfterTomorrow />
                    
                    {/* CUSTOM DATE - выборочная дата */}
                    <BlockCustomDate />
            </RadioGroup.Root>           
                
    )
}

export default DateBlock